import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export default class EmplyeeApi {
    /**
     *
     * @param {string} employeeId
     * @param {string} groupId
     * @param {undefined | string[]} statementIds
     * @param {undefined | boolean} doStatementChecks (default to false in backend)
     */
    static checkin(employeeId, groupId, statementIds, doStatementChecks) {
        return RESTClient.postAuthenticated(`v2/employees/${employeeId}/checkins`, {
            groupId,
            statementIds,
            doStatementChecks,
        });
    }

    static checkout(employeeId) {
        return RESTClient.postAuthenticated(`v2/employees/${employeeId}/checkout`);
    }

    static fetchAllEmployees(institutionId, future) {
        return RESTClient.getAuthenticated('v2/employees', {
            institutionId,
            future,
        });
    }

    static fetchSummary(employeeId) {
        return RESTClient.getAuthenticated(`v2/employees/${employeeId}/summary`);
    }

    static updateEmail(employeeId, email) {
        return RESTClient.postAuthenticated(`v2/employees/${employeeId}`, {
            email,
        });
    }
}
